import React from "react";
import { SnackbarProvider } from "notistack";

export function WithSnackbar<TProps extends {} = {}>(
  Child: React.ComponentType<TProps>
) {
  return (props: TProps) => (
    <SnackbarProvider
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      maxSnack={3}
      preventDuplicate
    >
      <Child {...props} />
    </SnackbarProvider>
  );
}
